import { WORK_METHOD_OPTIONS } from '../../../components/Table/projectDashboard/constants';

export const THAI_WEEKDAYS = ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'];

const WORK_OPTIONS = [
  { key: 'waiting', label: 'รอเข้าดำเนินการ', color: '#64748b' },
  { key: 'in_progress', label: 'ดำเนินการ', color: '#2563eb' },
  { key: 'done', label: 'เสร็จ 100%', color: '#059669' },
  { key: 'cancelled', label: 'ยกเลิก', color: '#6b7280' },
];
// "ด้านงาน" ใน StatusGroup โชว์ 5 ตัวเลือก — แตก 'in_progress' เป็น 3 วิธี (ทำเอง/จ้างเหมา/ผสม)
// ด้วย composite key "in_progress:<method>" (ดู workStatusCurrentKey/handleWorkStatusSelect)
export const WORK_OPTIONS_EXPANDED = [
  WORK_OPTIONS[0],
  ...WORK_METHOD_OPTIONS.map((m) => ({
    key: `in_progress:${m.key}`,
    label: m.label,
    color: m.color,
  })),
  WORK_OPTIONS[2],
  WORK_OPTIONS[3],
];
export const FINANCE_OPTIONS = [
  { key: 'none', label: 'ยังไม่เคยเบิก', color: '#94a3b8' },
  { key: 'partial', label: 'เบิกแล้วบางส่วน', color: '#f59e0b' },
  { key: 'billed_waiting', label: 'วางบิลแล้วรอรับเงิน', color: '#d97706' },
  { key: 'last_installment', label: 'รอรับงวดสุดท้าย', color: '#c2410c' },
  { key: 'completed_po', label: 'รับเงิน100%แล้ว', color: '#059669' },
];
export const BG_USAGE_OPTIONS = [
  { key: 'no_bg_usage', label: 'ไม่ใช้ BG แล้ว', color: '#059669' },
];
export const NO_BG_USAGE_KEY = 'no_bg_usage';
// legal_warranty คลิกแล้วเปิด popup กรอกวันครบกำหนดรับประกัน (warranty_end_date) แทนการ toggle ตรงๆ
// เพราะ backend derive legal_warranty จากวันที่เท่านั้น (ดู handleLegalToggle/commitWarrantyDate ใน
// ProjectSingleDashboard.js)
export const LEGAL_OPTIONS = [
  { key: 'legal_warranty', label: 'Warrant/Guarantee (W)', color: '#7c3aed' },
  { key: 'legal_debt', label: 'เจ้าหนี้ค้างจ่าย (D)', color: '#dc2626' },
  { key: 'legal_lawsuit', label: 'ฟ้องร้อง (L)', color: '#991b1b' },
  { key: 'legal_judged', label: 'พิพากษาแล้ว (J)', color: '#78350f' },
];
export const WARRANTY_COLOR = '#7c3aed';

// ความกว้างคงที่ของคอลัมน์ตัวเลข/เปอร์เซ็นต์ — ให้ทุกแถวในหมวดเดียวกันเรียงชิดขวาตรงแนวกัน
// เหมือนคอลัมน์ตัวเลขในตาราง ไม่ว่าความยาวของ label แต่ละแถวจะไม่เท่ากันก็ตาม
export const VALUE_COL_W = 92;
export const PCT_COL_W = 52;
export const PCT_TO_VALUE_GAP = 3;
export const VALUE_DEFAULT_CH = 12;
export const PCT_DEFAULT_CH = 7;

// ความกว้างกรอบตัวเลขคงที่ (คอลัมน์กลาง+ขวา แถว 1-19) — ไม่คำนวณตามข้อมูลของแต่ละโปรเจกต์อีกต่อไป
// กันกรอบขยับขนาดไม่เท่ากันข้ามโปรเจกต์ (โปรเจกต์เล็กหลักแสน vs โปรเจกต์ใหญ่หลักล้าน)
// กว้างพอรองรับค่าติดลบหลักร้อยล้าน เช่น "-999,999,999.99" โดยไม่ถูกตัด
export const SHARED_VALUE_WIDTH_PX = 130;

// เส้นกรอบบางสีจาง — ใช้แทนไอคอนปากกาเดิม บอกว่าช่องนี้แก้ไขได้ (กล่องข้อความบางๆ)
export const EDITABLE_BORDER = '1px solid #cbd5e1';
